import { FlexFileError } from './FlexFileError';

import {ReportDataService} from '../../report-data.service';

export class OrderOrLotAllocationError extends FlexFileError {

  protected reportService: ReportDataService;

  constructor(reportService: ReportDataService) {
    super(reportService, 'Order or Lot Item Needs Allocation', 'ORDER_OR_LOT_ALLOCATION', 0, false, null);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/errors/OrderOrLotAllocationError.ts